/* eslint-disable arrow-body-style */
import React from 'react';
import TransactionFeed from './TransactionFeed';

// In the future this repo might be used to display other
// stuff that just the transaction feed, so keeping the App
// component open for handling that.
const App = () => <TransactionFeed />;

export default App;
